export const COOKIE_CONSENT_DECISION_KEY = "vg_cookie_consent_decision";

const OPTIONAL_COOKIE_NAMES = new Set(["_ga", "_gid", "_gat", "_fbp", "_fbc"]);
const OPTIONAL_COOKIE_PREFIXES = ["_ga_", "_gat_", "_gac_"];
const OPTIONAL_STORAGE_PREFIXES = ["_ga", "_gid", "_gat", "_gac_", "_fbp", "_fbc"];

const isOptionalAnalyticsName = (name) => {
  const normalized = String(name || "").trim();
  return (
    OPTIONAL_COOKIE_NAMES.has(normalized) ||
    OPTIONAL_COOKIE_PREFIXES.some((prefix) => normalized.startsWith(prefix))
  );
};

function cookieNames() {
  if (typeof document === "undefined") return [];
  return String(document.cookie || "")
    .split(";")
    .map((part) => part.split("=")[0].trim())
    .filter(Boolean);
}

function expireCookie(name) {
  if (typeof document === "undefined") return;
  const encodedName = encodeURIComponent(name);
  const secure = typeof window !== "undefined" && window.location?.protocol === "https:"
    ? "; Secure"
    : "";
  const base = `${encodedName}=; Path=/; Max-Age=0; SameSite=Lax${secure}`;
  document.cookie = base;

  const hostname = String(
    (typeof window !== "undefined" && window.location?.hostname) || ""
  ).trim();
  const domainCandidates = new Set(["vaultgrid.net", ".vaultgrid.net"]);
  if (hostname.includes(".")) {
    domainCandidates.add(hostname);
    domainCandidates.add(`.${hostname.replace(/^\./, "")}`);
  }
  domainCandidates.forEach((domain) => {
    document.cookie = `${base}; Domain=${domain}`;
  });
}

function clearOptionalStorageArea(storage) {
  const removed = [];
  if (!storage) return removed;
  try {
    const keys = Array.from({ length: storage.length }, (_, index) => storage.key(index))
      .filter(Boolean);
    keys.forEach((key) => {
      if (OPTIONAL_STORAGE_PREFIXES.some((prefix) => key.startsWith(prefix))) {
        storage.removeItem(key);
        removed.push(key);
      }
    });
  } catch {
    // Storage may be unavailable in privacy mode.
  }
  return removed;
}

export function clearOptionalAnalyticsData() {
  const removedCookies = cookieNames().filter(isOptionalAnalyticsName);
  removedCookies.forEach(expireCookie);

  const removedStorageKeys = [];
  if (typeof window !== "undefined") {
    removedStorageKeys.push(...clearOptionalStorageArea(window.localStorage));
    removedStorageKeys.push(...clearOptionalStorageArea(window.sessionStorage));

    try {
      window.localStorage.setItem(COOKIE_CONSENT_DECISION_KEY, "rejected");
    } catch {
      // Keep clearing cookies even if localStorage is unavailable.
    }

    try {
      window.gtag?.("consent", "update", {
        analytics_storage: "denied",
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
      });
    } catch {
      // Best effort for an already-loaded Google tag.
    }

    try {
      window.fbq?.("consent", "revoke");
      window.__vgMetaPixelConsentGranted = false;
    } catch {
      // Best effort for an already-loaded Meta Pixel.
    }

    try {
      window.dispatchEvent(
        new CustomEvent("vg-cookie-consent-updated", {
          detail: { decision: "rejected", accepted: false },
        })
      );
    } catch {
      // Ignore event dispatch failures.
    }
  }

  return { removedCookies, removedStorageKeys };
}
